import { createElement } from 'react';

const SvgClose = (props) => (createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 32 32", fill: "currentColor" }, props),
    createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M.276.276a.941.941 0 011.33 0l30.118 30.117a.941.941 0 11-1.33 1.331L.275 1.607a.941.941 0 010-1.331z" }),
    createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M31.724.276a.941.941 0 00-1.33 0L.275 30.393a.941.941 0 101.33 1.331L31.725 1.607a.941.941 0 000-1.331z" })));

export default SvgClose;
